export default __webpack_public_path__ + "media/d82904dcf0a174e9430c1abcae82b6f63080fddbc9ffbb47297f63fe1a1dcf82.svg";